import { Utils } from "@/plugins/utils";
import router from '@/router';
const scanOk = require('../../../public/audio/scanOk.wav')

export default {
	namespaced: true,
	state: {
		lstMe2: [],
		lstMe2ToDelete: [],
		me2: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 1000,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, me2){
			state.me2 = me2
			if (me2)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.me2 = null
			state.lstMe2 = []
			state.lstMe2ToDelete = []
		},
		setParamsDataTable(state, payload){
			state.lstMe2 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, {me2doc, me2insumo, me2cor, me2tamanho, me2lote, me2ender, me2volume, me2operest}){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Stock/InventoryMovementItems/Find?me2doc=${me2doc}&me2insumo=${me2insumo}&me2cor=${me2cor}&me2tamanho=${me2tamanho}&me2lote=${me2lote}&me2ender=${me2ender}&me2volume=${me2volume}&me2operest=${me2operest}`)
			.then(response => {
				let me2 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", me2)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async save(store, me1form){
			if ((me1form && !store.state.me2.new) || (!me1form && !!store.state.me2.me2doc)){
				return await store.dispatch("update")
			}
			return await store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
		
			let payload = await this._vm.$axios.post("/Stock/InventoryMovementItems/Insert", store.state.me2 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/itens-movimentacoes-fisicas")
				store.state.me2 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
		
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		
			return payload
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
		
			let payload = await this._vm.$axios.put("/Stock/InventoryMovementItems/Update", store.state.me2 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/itens-movimentacoes-fisicas")
				store.state.me2 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
		
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		
			return payload
		},
		async deleteAll(store, me1doc){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo itens movimentados", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.delete(`/Stock/InventoryMovementItems/Delete/${me1doc}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.delete(`/Stock/InventoryMovementItems/Delete?me2doc=${store.state.me2.me2doc}&me2insumo=${store.state.me2.me2insumo}&me2cor=${store.state.me2.me2cor}&me2tamanho=${store.state.me2.me2tamanho}&me2lote=${store.state.me2.me2lote}&me2ender=${store.state.me2.me2ender}&me2volume=${store.state.me2.me2volume}&me2operest=${store.state.me2.me2operest}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			
			return payload
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Stock/InventoryMovementItems/FindList")
			.then(response => {
				let lstMe2 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstMe2 = lstMe2
				store.state.hasNext = lstMe2.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstMe2 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async findByDoc(store, me2doc){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Stock/InventoryMovementItems/FindByDoc/"+me2doc)
			.then(response => {
				let lstMe2 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstMe2 = lstMe2
				store.state.hasNext = lstMe2.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstMe2 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Stock/InventoryMovementItems/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstMe2 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async validateQuantity(store, me2){

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Validando quantidade digitada", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post(`/Stock/InventoryMovementItems/ValidateQuantity?forUpdate=${!me2.new}`, me2)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		addItem(store){
			var audio = new Audio(scanOk);
			
			let me2 = store.state.lstMe2.filter(me2 => me2.me2insumo === store.state.me2.me2insumo)[0]
			if (!!me2) {
				me2.me2qtde++
				me2.toSave = true
			}else{
				store.state.lstMe2.unshift(store.state.me2)
			}
			audio.play();
			return true
		},
		removeItem(store){
			store.state.lstMe2 = store.state.lstMe2.filter(me2 => me2.me2insumo != store.state.me2.me2insumo)

			store.state.me2 = null
			
			return true
		},
		addToRemove(store){
			let me2 = store.state.lstMe2.filter(me2 => me2.me2insumo === store.state.me2.me2insumo)[0]
			if (!me2)
				return false
			
			store.state.lstMe2ToDelete.push(me2)
			
			return true
		}
	}
}